import * as tslib_1 from "tslib";
import MailListItemContainer from './MailListItemContainer';
import getMailListItemDataProps from '../utils/getMailListItemDataProps';
import { observer } from 'mobx-react';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import * as React from 'react';
var MailListItemDataProvider = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemDataProvider, _super);
    function MailListItemDataProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailListItemDataProvider.prototype.render = function () {
        if (this.props.mailListTableProps.listViewType == 0 /* Conversation */) {
            var tableConversationRelation = getTableConversationRelation(this.props.rowKey, this.props.mailListTableProps.tableViewId);
            if (!tableConversationRelation) {
                // Bug 1051: Investigate mobx behavior of calling render for a single removed item before calling render on the list
                // Table relation may be null if this conversation is in the process of being removed from render.
                // Mobx calls render on this item before calling the mail list's render.
                return null;
            }
        }
        // Remark: The reason we have this wrapper component around MailListItem is to minimize the number of re-renders.
        // Since getting mail list item data props will bind to all item props for the row, we don't want to do this in MailListContent and cause
        // the list of re-render when a single item's prop changes. We also don't want to do this inside MailListItem because we want to pass this as props
        // so that computed properties can use these properties for computed states.
        var mailListItemDataProps = getMailListItemDataProps(this.props.rowKey, this.props.mailListTableProps);
        return (
        // VSO 25058: Investigate why conversationItem not found in store in getMailListItemDataProps
        mailListItemDataProps && (React.createElement(MailListItemContainer, { mailListTableProps: this.props.mailListTableProps, mailListItemDataProps: mailListItemDataProps, resetListViewContentTabIndex: this.props.resetListViewContentTabIndex, isFocusInMailList: this.props.isFocusInMailList })));
    };
    MailListItemDataProvider = tslib_1.__decorate([
        observer
    ], MailListItemDataProvider);
    return MailListItemDataProvider;
}(React.Component));
export default MailListItemDataProvider;
//# sourceMappingURL=MailListItemDataProvider.js.map